import React from "react";
import { Link } from "react-router-dom";
import {
  FaBuilding,
  FaUsers,
  FaHandshake,
  FaGavel,
  FaLaptopCode,
  FaLeaf,
} from "react-icons/fa";

// Brand reference (same family as Hero / About):
// ink #0E0E0D · charcoal #55524C · accent #7A1F2B · accent light #A8485A
const DISPLAY_FONT = "'Playfair Display', Georgia, serif";

const practices = [
  {
    id: "01",
    title: "Special Leave Petition (SLP)",
    desc: "Expert representation before the Supreme Court in challenging judgments and orders passed by lower courts and tribunals.",
    icon: <FaBuilding />,
    link: "/services/slp",
  },
  {
    id: "02",
    title: "Public Interest Litigation (PIL)",
    desc: "Legal action for protecting public rights, promoting social justice, and addressing issues affecting the larger community.",
    icon: <FaGavel />,
    link: "/services/pil",
  },
  {
    id: "03",
    title: "Anticipatory Bail",
    desc: "Comprehensive legal assistance in securing anticipatory bail to protect individuals from arrest in criminal matters.",
    icon: <FaUsers />,
    link: "/services/anticipatory-bail",
  },
  {
    id: "04",
    title: "Writ Petition",
    desc: "Effective remedies against violations of fundamental and legal rights through constitutional writ petitions.",
    icon: <FaHandshake />,
    link: "/services/writ-petition",
  },
  {
    id: "05",
    title: "Central Administrative Tribunal (CAT)",
    desc: "Professional representation in service matters, employment disputes, promotions, transfers, and disciplinary proceedings.",
    icon: <FaLaptopCode />,
    link: "/services/cat",
  },
  {
    id: "06",
    title: "Transfer Petition (TP)",
    desc: "Assistance in seeking transfer of cases between courts to ensure convenience, fairness, and the interests of justice.",
    icon: <FaLeaf />,
    link: "/services/tp",
  },
];
const PracticeAreas = () => {
  return (
    <section className="flex min-h-screen flex-col justify-center bg-white px-5 py-16 sm:px-8 sm:py-20 lg:px-16 lg:py-24 xl:px-28">
      <div className="mx-auto w-full max-w-7xl">

        {/* Header */}
        <div className="mb-10 flex flex-col items-center text-center sm:mb-14 lg:mb-16">
          <div className="mb-3 flex items-center gap-2 sm:mb-4 sm:gap-3">
            <span className="h-px w-6 bg-black/20 sm:w-8" />
            <span className="text-[9px] font-bold uppercase tracking-[0.3em] text-[#A8485A] sm:text-[10px] sm:tracking-[0.4em]">
              Our Specializations
            </span>
            <span className="h-px w-6 bg-black/20 sm:w-8" />
          </div>
          <h2
            className="text-3xl font-bold leading-tight text-[#0E0E0D] sm:text-4xl md:text-5xl"
            style={{ fontFamily: DISPLAY_FONT }}
          >
            Areas of <span className="font-light text-black/40">Legal</span> Excellence
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 gap-px overflow-hidden border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-3">
          {practices.map((item) => (
            <Link
              key={item.id}
              to={item.link}
              className="group relative flex flex-col justify-between overflow-hidden bg-white p-6 transition-colors duration-500 hover:bg-[#FBF9F6] sm:p-8 lg:p-9"
            >
              {/* Faint number watermark */}
              <span
                className="pointer-events-none absolute -bottom-2 -right-1 select-none text-[3.5rem] font-bold leading-none text-[#0E0E0D] opacity-[0.04] sm:-bottom-3 sm:text-[4.5rem] lg:text-[5.5rem]"
                style={{ fontFamily: DISPLAY_FONT }}
              >
                {item.id}
              </span>

              <div className="relative z-10">
                <div className="mb-5 flex items-center justify-between sm:mb-6 lg:mb-7">
                  <div className="flex h-11 w-11 items-center justify-center rounded-full border border-black/10 text-base text-[#0E0E0D] transition-all duration-500 group-hover:border-[#7A1F2B]/30 group-hover:bg-[#7A1F2B]/5 group-hover:text-[#7A1F2B] sm:h-12 sm:w-12 sm:text-lg lg:h-14 lg:w-14 lg:text-xl">
                    {item.icon}
                  </div>
                  <span className="text-[10px] font-semibold tracking-[0.25em] text-[#A8485A] sm:text-xs sm:tracking-[0.3em]">
                    {item.id}
                  </span>
                </div>

                <h3 className="mb-2 text-lg font-bold uppercase tracking-wide text-[#0E0E0D] sm:mb-3 sm:text-xl">
                  {item.title}
                </h3>

                <p className="text-sm leading-relaxed text-[#55524C] sm:text-base">
                  {item.desc}
                </p>
              </div>

              {/* Learn More */}
              <div className="relative z-10 mt-6 flex -translate-y-2 items-center gap-2 text-[10px] font-semibold uppercase tracking-widest text-[#7A1F2B] opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100 sm:mt-8 sm:text-xs">
                Learn more <span className="text-base">→</span>
              </div>

              {/* Hover top border */}
              <div className="absolute left-0 top-0 h-[2px] w-0 bg-[#7A1F2B] transition-all duration-700 group-hover:w-full" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;